import clsx from 'clsx'
import React, { useCallback, useState } from 'react'
import { useControlField, useField } from 'remix-validated-form'
import { Checkbox, Label } from '~/components/ui'
import { cn } from '~/utils'

type CheckboxFieldProps = {
  className?: string
  label: string
  name: string
  disabled?: boolean
  defaultValue?: boolean
  onBlur?: () => void
  onCheckedChange?: (value: string | boolean) => void
}

const CheckboxField = React.memo(function CheckboxField(
  props: CheckboxFieldProps
) {
  const {
    className,
    name,
    label,
    disabled,
    defaultValue,
    onBlur: customOnBlur,
    onCheckedChange,
  } = props
  const { error, getInputProps, defaultValue: previousValue } = useField(name)
  const { onBlur } = getInputProps()
  const [value, setValue] = useControlField(name)
  const [hasInteracted, setHasInteracted] = useState(false)

  const handleCheckedChange = useCallback(
    (value: string | boolean) => {
      if (!hasInteracted) {
        setHasInteracted(true)
      }
      setValue(value.valueOf())
      onCheckedChange?.(value.valueOf())
      customOnBlur?.()
      onBlur?.()
    },
    [setValue, onCheckedChange, customOnBlur, onBlur, hasInteracted]
  )

  const checkboxClassName = React.useMemo(() => {
    return clsx(
      hasInteracted &&
        previousValue &&
        value != previousValue &&
        'text-yellow-300 ring-2 ring-yellow-300 ring-offset-2'
      // ((!previousValue && value === true) || value === 'on') &&
      //   'text-green-400 ring-2 ring-offset-2 ring-green-400'
    )
  }, [previousValue, value, hasInteracted])

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      <Checkbox
        id={name}
        name={name}
        disabled={disabled}
        checked={typeof value !== 'undefined' ? !!value : defaultValue}
        onCheckedChange={handleCheckedChange}
        className={checkboxClassName}
      />
      <Label htmlFor={name} className="font-normal leading-tight">
        {label}
      </Label>
    </div>
  )
})

export default CheckboxField
